'use client';

import React, { forwardRef } from 'react';
import { cn } from '@/components/ui/_lib/cn';
import type { UiSkeletonProps } from '@/components/ui/_lib/skeletonProps';
import { useDeferredSkeleton } from '@/components/ui/_lib/useDeferredSkeleton';
import { SkeletonLines } from '@/components/ui/_lib/SkeletonLines';
import { SKELETON_BY_COMPONENT } from '@/components/ui/_lib/skeletonRegistry';

export type UlProps = React.HTMLAttributes<HTMLUListElement> & {
  variant?: 'default' | 'no-bullet';
  'aria-label'?: string;
} & UiSkeletonProps;

const sk = SKELETON_BY_COMPONENT.Ul;

const Ul = forwardRef<HTMLUListElement, UlProps>((props, ref) => {
  const {
    skeleton = false,
    skeletonMaxWaitMs = 2000,
    skeletonLines,
    className,
    children,
    ...domProps
  } = props;

  const showSkeleton = useDeferredSkeleton(skeleton, skeletonMaxWaitMs);

  return (
    <ul       ref={ref}
      className={cn('group', 'ul', className)}
      {...domProps}
    >
      <SkeletonLines show={showSkeleton} shape={sk.shape} lines={skeletonLines ?? sk.lines}>
        {children}
      </SkeletonLines>
    </ul>
  );
});

Ul.displayName = 'Ul';

export default Ul;
